import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { IBarChartModel } from '@types-custom/models/ui/bar-chart-model';

/*
** Sit Bar Chart
** Render a bar chart
*/

@Component({
  selector: 'sit-bar-chart',
  templateUrl: './sit-bar-chart.component.html',
  styleUrls: ['./sit-bar-chart.component.scss']
})
export class SitBarChartComponent implements OnInit, OnChanges {

  @Input() properties: IBarChartModel = {
    tid: 0,
    dataAll: [],
    type: 1
  }

  chartData = [
    {name:"Bueno", value:0, color: "#02722E80", bcolor: "#0F6E2C", bstyle: "solid", bwidth: "1px"} ,
    {name:"medio", value:0, color: "#D5910480", bcolor: "#D59104", bstyle: "solid", bwidth: "1px"} ,
    {name:"lento", value:0, color: "#8E050580", bcolor: "#8E0509", bstyle: "solid", bwidth: "1px"}
  ];

  colorChartMap: { [key: string]: any } = {
    ['green']: () => {
      return {
        id: 1,
        name: "Bueno",
        color: "#02722E80"
      }
    },
    ['yellow']: () => {
      return {
        id: 2,
        name: "medio",
        color: "#D5910480"
      }
    },
    ['red']: () => {
      return {
        id: 3,
        name: "lento",
        color: "#8E050580"
      }
    },
  }


  constructor() {
    //
   }

  ngOnInit(): void {
    this.FillData([]);
  }

  ngOnChanges(changes: SimpleChanges){

    if(changes.properties) {
      if (this.properties.type == 1){

        this.properties.dataSource?.gettraveltimesAvgTid(this.properties.tid.toString())
        .subscribe((list: any) => {

          this.FillData(list);

        });

      }
      else {
        if (this.properties.dataAll !== undefined) {
          const items = this.properties.dataAll.filter(( x: any )=> x.tid == changes.properties.currentValue.tid);
          this.FillData(items);
        } else {
          this.FillData([]);
        }
      }

    }

  }

  FillData(list: any){
    let totTimes = 0;

    list.forEach((element: any) => {
      totTimes = totTimes + element.count;
    });

    this.chartData = list.map((item: any) => {
      let d: any = new Object();

      d = this.colorChartMap[item.levelOfService](item);

      d['value'] = ((100*item.count)/totTimes).toFixed(2);

      return d;

    });

    this.chartData.sort((a: any, b: any) => {
      if (a["id"] > b["id"]) {
        return 1;
      }
      if (a["id"] < b["id"]) {
        return -1;
      }

      return 0;
    });
  }

}
